export const Permission = {
  // AADE
  UseAadeMyData: 'use_aade_mydata',

  // Students
  ManageStudents: 'manage_students',
  ViewStudents: 'view_students',

  // Lessons
  CreateLesson: 'create_lesson',
  EditLesson: 'edit_lesson',
  DeleteLesson: 'delete_lesson',

  // Contracts
  ManageContracts: 'manage_contracts',

  // Files
  ManageFiles: 'manage_files',

  // Notifications
  SendNotifications: 'send_notifications',
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];
